import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';

//importing components
import Login from './Components/Login/Login';
import Logout from './Logout';
import App from './App';
import Auth from './Auth';
import TagWriter from './Components/Tag Writer/TagWriter';
import Catalogue from './Components/Magazine-Catalogue/Catalogue';
// import McTagWriter from './Components/MC-Tag-Writer/McTagWriter';
// import PrintSapBook from './Components/Print-SAP-Book/PrintSapBook';
import Receive from './Components/Receive/Receive';
import ClosedCards from './Components/Receive-Closed-Cards/ClosedCards';
// import Sap from './Components/SAP-BOOKQC/Sap';
import SendOut from './Components/Sending-Out/SendOut';
import SortBook from './Components/SortBooks/SortBook';
import Dispatch from './Components/Dispatch/Dispatch';
import AddBooks from './Components/AddBooksToTitle/addBooks';
// import Errors from './404'

// import {Router, Route, browserHistory} from 'react-router-3';
import { HashRouter } from 'react-router-dom';
import {
    BrowserRouter,
    Route,
    Switch,
    Redirect
} from 'react-router-dom';
import Axios from 'axios';
import Fulfillment from './Components/Fulfill/fulfillment';
import SwapBooksSuggestion from './Components/SwapSuggestion/SwapBooksSuggestion';

Axios.interceptors.request.use(function (config) {
    // config.headers.Authorization =  'qwerty';
    config.headers['X-SECRET-TOKEN'] = 'qwerty'
    return config;
});

const checkAuth = () => {
    const shouldRedirect = sessionStorage.getItem('isLoggedIn');
    if (shouldRedirect) {
        return true;
    }
    else {
        return false;
    }
}

const logout = () => {
    sessionStorage.clear('isLoggedIn');
    sessionStorage.clear('loggedInUser');

    return true;
}

const AuthRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        checkAuth() ? (
            <Component {...props} />
        ) : (
                <Redirect to='/' />
            )
    )} />
)

const LogoutRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        logout() ? (
            <Redirect to={{ pathname: '/' }} />
        ) : (
                <Redirect to={{ pathname: '/' }} />
            )
    )} />
)

ReactDOM.render(

    <HashRouter>
        <Switch>
            <Route exact path='/' render={props => <Login {...props} />} />
            <LogoutRoute path='/logout' component={Logout} />
            <AuthRoute exact path="/auth" component={Auth} />
            <Route exact path='/app' render={() => <App num="2" />} />
            {/* component = {App} /> */}
            <AuthRoute exact path='/tagWriter' component={TagWriter} />
            <Route exact path='/addBooks' component={AddBooks} />

            {/* <AuthRoute exact path = '/mctagWriter'  component = {McTagWriter} /> */}
            <Route exact path='/receive' component={Receive} />
            <Route exact path='/sendout' component={SendOut} />
            <AuthRoute exact path='/sort' component={SortBook} />
            <AuthRoute exact path="/dispatch" component={Dispatch} />
            <AuthRoute exact path="/closedcards" component={ClosedCards} />
            <AuthRoute exact path="/catalogue" component={Catalogue} />
            <AuthRoute exact path="/fulfillment" component={Fulfillment} />
            <AuthRoute exact path="/swapSuggestion" component={SwapBooksSuggestion} />
            {/* <Route  path = "/*"    component = {Errors}    /> */}
            {/* <Route exact path = '/sort' render = {props => <SortBook {...props} />} /> */}
        </Switch>
    </HashRouter>

    , document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js